import MarkdownRenderer from '../Markdown/MarkdownRenderer';

const LegalNoticeContentFromMarkdown = () => {
  
  return (
    <div className="legal-content-markdown">
      <MarkdownRenderer file="/content/legal-notice.md" />
    </div>
  );
};

export default LegalNoticeContentFromMarkdown;
